import { trace } from "@opentelemetry/api";
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

export function createInstrumentedQueryClient() {
  const tracer = trace.getTracer("customer-portal-ui");

  const queryCache = new QueryCache({
    onError: (error, query) => {
      const span = tracer.startSpan("query.error");
      span.setAttribute("query.key", JSON.stringify(query.queryKey));
      span.setAttribute("error.message", String(error));
      span.end();
    },
    onSuccess: (_data, query) => {
      const span = tracer.startSpan("query.success");
      span.setAttribute("query.key", JSON.stringify(query.queryKey));
      span.setAttribute("query.hasData", query.state.dataUpdatedAt > 0);
      span.end();
    },
  });

  const mutationCache = new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      const span = tracer.startSpan("mutation.error");
      span.setAttribute("mutation.key", String(mutation.options.mutationKey));
      span.setAttribute("error.message", String(error));
      span.end();
    },
    onSuccess: (_data, _variables, _context, mutation) => {
      const span = tracer.startSpan("mutation.success");
      span.setAttribute("mutation.key", String(mutation.options.mutationKey));
      span.end();
    },
  });

  return new QueryClient({
    queryCache,
    mutationCache,
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5,
        gcTime: 1000 * 60 * 10,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
